import { render } from "./TechItsResourceCenterComp.vue?vue&type=template&id=5ba19f50&scoped=true"
import script from "./TechItsResourceCenterComp.vue?vue&type=script&lang=js"
export * from "./TechItsResourceCenterComp.vue?vue&type=script&lang=js"

import "./TechItsResourceCenterComp.vue?vue&type=style&index=0&id=5ba19f50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba19f50"]])

export default __exports__